import { Dispatch } from 'react'
import {
  TypedUseSelectorHook,
  useDispatch,
  useSelector,
  useStore
} from 'react-redux'
import { Store } from 'redux'
import { ActivityAction } from './activity/actions'
import { ActivityLogActions } from './activityLog/actions'
import { ActivityTickerAction } from './admin/activityTicker/actions'
import { AggressAttemptAction } from './admin/aggressAttempt/actions'
import { BBMISINAction } from './admin/bbmisin/actions'
import { TickerRatingAction } from './admin/tickerRating/actions'
import { ExternalLiquidityStatsAction } from './admin/externalLiquidityStats/actions'
import { ManagementReportAction } from './admin/managementReports/actions'
import { QueueStatsAction } from './admin/queueStats/actions'
import { RestrictedTradesAction } from './admin/restrictedTrades/actions'
import { SystemParamAction } from './admin/sysparam/actions'
import { TierAction } from './admin/tiers/actions'
import { UserDashboardAction } from './admin/userDashboard/actions'
import { UserDataAction } from './admin/userData/actions'
import { VenueAction } from './admin/venues/actions'
import { AlertFilterAction } from './alertFilter/actions'
import { AlertsAction } from './alerts/actions'
import reducer from './appReducer'
import { AuthAction } from './auth/actions'
import { BenchmarkDataAction } from './benchmarkData/actions'
import { BookAction } from './books/actions'
import { CheckedOrderAction } from './checkedOrders/actions'
import { CustomersAction } from './customers/actions'
import { DepthOfMarketAction } from './depthOfMarket/actions'
import { GridAction } from './grid/actions'
import { HeartbeatAction } from './heartbeat/actions'
import { LastLookAction } from './lastLook/actions'
import { ListTradingAction } from './listTrading/actions'
import { LogAction } from './log/actions'
import { MarketAction } from './market/actions'
import {
  CreateOrderAction,
  CreateOrdersAction,
  OrderAction
} from './order/actions'
import { PassiveOrdersAction } from './passiveOrders/actions'
import { RFQActions } from './rfq/actions'
import { SearchSecuritiesActions } from './searchSecurities/actions'
import {
  FetchSecuritiesByIdsAction,
  GridViewStateAction,
  SecuritiesAction,
  SetIsMine,
  SetUseAdvancedFilter,
  SubscribeGridViewportAction
} from './securities/actions'
import { SettingsAction } from './settings/actions'
import { StagedOrdersAction } from './stagedOrders/actions'
import { ToastAction } from './toasts/actions'
import { TradeBlotterActions } from './tradeBlotter/actions'
import { WindowFrameAction } from './windowFrame/actions'
import { UploadOrdersActions } from './upload/actions'
import { UserEditorDataAction } from './userEditorData/actions'
import { UserPreferencesAction } from './userPreferences/actions'
import { UsersAction } from './users/actions'
import {
  FetchBackgroundDetailsAction,
  WatchListsAction
} from './watchList/actions'
import { WebSettingsAction } from './webSettings/actions'
import { WindowsAction } from './windows/actions'
import { WsAction } from './ws/actions'

export type StoreAction =
  | ActivityAction
  | ActivityLogActions
  | ActivityTickerAction
  | AggressAttemptAction
  | AlertsAction
  | AlertFilterAction
  | AuthAction
  | BBMISINAction
  | BenchmarkDataAction
  | BookAction
  | CheckedOrderAction
  | CustomersAction
  | DepthOfMarketAction
  | ExternalLiquidityStatsAction
  | FetchBackgroundDetailsAction
  | FetchSecuritiesByIdsAction
  | GridAction
  | GridViewStateAction
  | HeartbeatAction
  | LastLookAction
  | ListTradingAction
  | LogAction
  | ManagementReportAction
  | MarketAction
  | OrderAction
  | CreateOrdersAction
  | CreateOrderAction
  | PassiveOrdersAction
  | QueueStatsAction
  | RestrictedTradesAction
  | RFQActions
  | SearchSecuritiesActions
  | SecuritiesAction
  | SettingsAction
  | SetIsMine
  | SetUseAdvancedFilter
  | StagedOrdersAction
  | SubscribeGridViewportAction
  | SystemParamAction
  | TickerRatingAction
  | TierAction
  | ToastAction
  | TradeBlotterActions
  | WindowFrameAction
  | UploadOrdersActions
  | UserDashboardAction
  | UserDataAction
  | UserEditorDataAction
  | UserPreferencesAction
  | UsersAction
  | WatchListsAction
  | WebSettingsAction
  | WindowsAction
  | WsAction
  | VenueAction
export type State = ReturnType<typeof reducer>
export const useAppSelector: TypedUseSelectorHook<State> = useSelector
export const useAppDispatch: () => Dispatch<StoreAction> = useDispatch
export const useAppStore: () => Store<State, StoreAction> = useStore

export type DataTableContainer<T> = {
  initialized: boolean
  rows: T[]
}

export type StoreActionTypes = StoreAction['type']
